const isLoopbackHost = (hostname) => ['localhost', '127.0.0.1', '::1'].includes(hostname);

export const getBackendBaseUrl = () => {
  const configured = process.env.REACT_APP_BACKEND_URL;
  const browserLocation = typeof window !== 'undefined' ? window.location : null;

  if (configured) {
    try {
      const configuredUrl = new URL(configured, browserLocation?.origin);
      if (browserLocation && isLoopbackHost(configuredUrl.hostname) && !isLoopbackHost(browserLocation.hostname)) {
        return `${browserLocation.protocol}//${browserLocation.hostname}:${configuredUrl.port || '8001'}`;
      }
      return configuredUrl.origin;
    } catch {
      return configured;
    }
  }

  if (!browserLocation) {
    return '';
  }

  if (browserLocation.port === '3000') {
    return `${browserLocation.protocol}//${browserLocation.hostname}:8001`;
  }

  return browserLocation.origin;
};
